import { render } from "./ItemPriceImport.vue?vue&type=template&id=3fabf38f"
import script from "./ItemPriceImport.vue?vue&type=script&lang=js"
export * from "./ItemPriceImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__